import { ImageLoaderCSSStyleImpl } from '../imageloader/imageloadercss';


export class MenuCategoriesImageLoaderCSSStyleImpl extends ImageLoaderCSSStyleImpl
{
    getImgCSSStyle(): object 
    {
        return {
            objectFit: 'cover', 
            width: '100%', 
            height: '100%',
            borderRadius: "28.5px",
            cursor: "pointer",
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/mobilemenu/menucategoriesimageloadercss.ts